import { useQuery } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import type {
  OwnerBillingOverviewResponse,
  OwnerSubscriptionPaymentsResponse,
  OwnerMessagePurchasesResponse,
  OwnerMessageCreditsResponse,
  OwnerMessagingSubscriptionPaymentsResponse,
} from '@/types/backend'

export const useOwnerBillingOverviewQuery = (enabled = true) =>
  useQuery({
    queryKey: ['owner-billing-overview'],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<OwnerBillingOverviewResponse>(
        '/owners/me/billing/overview'
      )
      return data
    },
  })

export const useOwnerSubscriptionPaymentsQuery = (enabled = true, take = 20) =>
  useQuery({
    queryKey: ['owner-subscription-payments', take],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<OwnerSubscriptionPaymentsResponse>(
        '/owners/me/billing/subscription-payments',
        { params: { take } }
      )
      return data
    },
  })

export const useOwnerMessagingSubscriptionPaymentsQuery = (
  enabled = true,
  take = 20
) =>
  useQuery({
    queryKey: ['owner-messaging-subscription-payments', take],
    enabled,
    queryFn: async () => {
      const { data } =
        await apiClient.get<OwnerMessagingSubscriptionPaymentsResponse>(
          '/owners/me/billing/messaging-subscription-payments',
          { params: { take } }
        )
      return data
    },
  })

export const useOwnerMessageCreditsQuery = (enabled = true, take = 20) =>
  useQuery({
    queryKey: ['owner-message-credits', take],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<OwnerMessageCreditsResponse>(
        '/owners/me/billing/message-credits',
        { params: { take } }
      )
      return data
    },
  })

export const useOwnerMessagePurchasesQuery = (enabled = true, take = 50) =>
  useQuery({
    queryKey: ['owner-message-purchases', take],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<OwnerMessagePurchasesResponse>(
        '/owners/me/billing/message-purchases',
        { params: { take } }
      )
      return data
    },
  })
